var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "current",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2375 5113 c-105 -7 -325 -45 -450 -77 -342 -89 -689 -264 -975 -492 -105 -84 -294 -272 -380 -378 -295 -365 -486 -809 -551 -1286 -17 -124 -17 -496 0 -620 67 -488 257 -930 565 -1310 77 -96 270 -289 366 -366 380 -308 822 -498 1310 -565 124 -17 496 -17 620 0 477 65 921 256 1286 551 106 86 294 275 378 380 168 211 332 500 422 745 87 238 140 516 150 785 27 708 -241 1386 -746 1890 -528 529 -1239 793 -1995 743z m-752 -1221 c34 -15 119 -91 322 -289 152 -147 354 -344 451 -437 l175 -169 442 440 c493 491 477 478 612 478 86 -1 145 -25 205 -85 60 -60 84 -119 85 -205 0 -135 13 -119 -479 -612 l-440 -443 440 -442 c492 -494 479 -478 479 -613 -1 -86 -25 -145 -85 -205 -60 -60 -119 -84 -205 -85 -135 0 -119 -13 -612 478 l-442 440 -175 -169 c-97 -93 -299 -290 -451 -437 -311 -303 -323 -312 -445 -312 -91 0 -149 24 -210 85 -60 60 -84 119 -85 205 0 135 -13 119 479 613 l440 442 -436 438 c-345 345 -441 447 -458 485 -112 254 140 511 393 399z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclude);
export default __webpack_public_path__ + "static/media/exclude.fd10a52a99d9e104357e53e7795e04ea.svg";
export { ForwardRef as ReactComponent };